function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fully-responsive_svg__a",
  x1: 681.66,
  y1: 793.64,
  x2: 681.66,
  y2: 89.9,
  gradientTransform: "matrix(.98 0 0 1.01 12.18 -5.36)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fully-responsive_svg__b",
  x1: 682.5,
  y1: 733.91,
  x2: 682.5,
  y2: 143.66,
  gradientTransform: "matrix(.98 0 0 1.01 12.18 -5.36)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fully-responsive_svg__c",
  x1: 443.89,
  y1: 807.45,
  x2: 443.89,
  y2: 260.81,
  gradientTransform: "matrix(1 0 0 1.03 .11 -13.69)",
  xlinkHref: "#fully-responsive_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 449.17,
  y: 85.17,
  width: 463.01,
  height: 708.67,
  rx: 17.17,
  ry: 17.17,
  transform: "rotate(-.08 -60275.886 206186.983)",
  fill: "url(#fully-responsive_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-.08 -60275.886 206186.983)",
  fill: "url(#fully-responsive_svg__b)",
  d: "M481.58 139.3h399.85v594.38H481.58z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 458.46,
  y: 90.09,
  width: 443.39,
  height: 681.66,
  rx: 17.17,
  ry: 17.17,
  transform: "rotate(-.08 -60275.88 206179.82)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7ebc89",
  d: "M201.748 57.516l382.91-.534.798 571.73-382.91.534z"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 682.42,
  cy: 742.29,
  r: 15.78,
  transform: "translate(-288.36 -83.96)",
  fill: "#dbdbdb"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 614.25,
  cy: 117.53,
  r: 5.26,
  transform: "rotate(-.08 -60340.129 205878.973)",
  fill: "#dbdbdb"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 640.55,
  y: 114.29,
  width: 68.38,
  height: 5.26,
  rx: 1.43,
  ry: 1.43,
  transform: "rotate(-.08 -60282.833 205879.013)",
  fill: "#dbdbdb"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 287.73,
  y: 253.95,
  width: 312.56,
  height: 560.98,
  rx: 10,
  ry: 10,
  transform: "rotate(-.08 -60505.134 206279.929)",
  fill: "url(#fully-responsive_svg__c)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 294.91,
  y: 259.74,
  width: 298.17,
  height: 533.76,
  rx: 10,
  ry: 10,
  transform: "rotate(-.08 -60505.129 206272.767)",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#7ebc89",
  d: "M40.925 212.731l230.84-.322.606 434.37-230.84.322z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 444.32,
  cy: 763.13,
  r: 18.41,
  transform: "rotate(-.08 -60505.289 206501.95)",
  fill: "#dbdbdb"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 408.69,
  cy: 277.27,
  r: 3.68,
  transform: "rotate(-.08 -60540.774 206036.396)",
  fill: "#dbdbdb"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 425.26,
  y: 274.45,
  width: 57.06,
  height: 5.52,
  rx: 1.5,
  ry: 1.5,
  transform: "rotate(-.08 -60497.797 206029.265)",
  fill: "#dbdbdb"
});

function SvgFullyResponsive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 625.28,
    height: 730.24
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

export default "data:image/svg+xml;base64,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";
export { SvgFullyResponsive as ReactComponent };